"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gavardo": {
    "bc385dc7": [{
      "hkey": "1630981d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-sopraponte": [{
      "hkey": "1630981d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "003a27ad": [{
      "hkey": "74d70053",
      "slug": "monte-magno",
      "name": "Monte Magno",
      "primary": true,
      "skipSearch": false
    }],
    "magno": [{
      "hkey": "74d70053",
      "slug": "monte-magno",
      "name": "Monte Magno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c0fcf70c": [{
      "hkey": "89916019",
      "slug": "soprazocco",
      "name": "Soprazocco",
      "primary": true,
      "skipSearch": false
    }],
    "benecco": [{
      "hkey": "89916019",
      "slug": "soprazocco",
      "name": "Soprazocco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gavardo"
    }],
    "e31ffe37": [{
      "hkey": "d143caed",
      "slug": "gavardo",
      "name": "Gavardo",
      "primary": true,
      "skipSearch": false
    }],
    "bussaga": [{
      "hkey": "d143caed",
      "slug": "gavardo",
      "name": "Gavardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "663ca682": [{
      "hkey": "d143caed",
      "slug": "gavardo",
      "name": "Gavardo",
      "primary": true,
      "skipSearch": false
    }],
    "caderusso": [{
      "hkey": "d143caed",
      "slug": "gavardo",
      "name": "Gavardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f678446e": [{
      "hkey": "1630981d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "casalicolo": [{
      "hkey": "1630981d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6ea1b56c": [{
      "hkey": "89916019",
      "slug": "soprazocco",
      "name": "Soprazocco",
      "primary": true,
      "skipSearch": false
    }],
    "corti": [{
      "hkey": "89916019",
      "slug": "soprazocco",
      "name": "Soprazocco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gavardo"
    }],
    "c9b3b4ec": [{
      "hkey": "3975d9fd",
      "slug": "soseto-fostaga",
      "name": "Soseto-Fostaga",
      "primary": true,
      "skipSearch": false
    }],
    "fostaga": [{
      "hkey": "3975d9fd",
      "slug": "soseto-fostaga",
      "name": "Soseto-Fostaga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gavardo"
    }],
    "3aef5dac": [{
      "hkey": "89916019",
      "slug": "soprazocco",
      "name": "Soprazocco",
      "primary": true,
      "skipSearch": false
    }],
    "piazze": [{
      "hkey": "89916019",
      "slug": "soprazocco",
      "name": "Soprazocco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gavardo"
    }],
    "4987a921": [{
      "hkey": "1630981d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "quarena": [{
      "hkey": "1630981d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e930a3ef": [{
      "hkey": "89916019",
      "slug": "soprazocco",
      "name": "Soprazocco",
      "primary": true,
      "skipSearch": false
    }],
    "san-biagio": [{
      "hkey": "89916019",
      "slug": "soprazocco",
      "name": "Soprazocco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gavardo"
    }],
    "5c232428": [{
      "hkey": "89916019",
      "slug": "soprazocco",
      "name": "Soprazocco",
      "primary": true,
      "skipSearch": false
    }],
    "san-giacomo": [{
      "hkey": "89916019",
      "slug": "soprazocco",
      "name": "Soprazocco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gavardo"
    }],
    "e5993dec": [{
      "hkey": "1630981d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "sopraponte-borzina": [{
      "hkey": "1630981d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "046c0c1c": [{
      "hkey": "89916019",
      "slug": "soprazocco",
      "name": "Soprazocco",
      "primary": true,
      "skipSearch": false
    }],
    "soprazocco-bariaga": [{
      "hkey": "89916019",
      "slug": "soprazocco",
      "name": "Soprazocco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5dbf8e76": [{
      "hkey": "3975d9fd",
      "slug": "soseto-fostaga",
      "name": "Soseto-Fostaga",
      "primary": true,
      "skipSearch": false
    }],
    "soseto": [{
      "hkey": "3975d9fd",
      "slug": "soseto-fostaga",
      "name": "Soseto-Fostaga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;